import { post } from './api.js'

export function callRunUpdates(payload) {
  return post('/api/auth/run-updates', payload)
}

export function callUpdateSettings(payload) {
  return post('/api/auth/update-settings', payload)
}

export function callSetWebsiteSettings(client) {
  const clients = [
    'client1',
    'client1contributor',
    'client2',
    'client1cloud',
    'client2cloud',
  ]
  const endpoint = clients.includes(client)
    ? 'central-settings'
    : 'tenant-settings'

  return post(`/api/${endpoint}`, { client })
}
